import { formatDecimal } from "../components/charts/format";

// Os onze intervalos da duracao de uma mensagem de voz. O backend guarda o histograma em passos de 1 s
// ate aos 90 s, e o ultimo passo, 90 000, e aberto ("90 s ou mais"): cada chave e o inicio do seu passo.
// Cada inicio daqui tem de cair num passo guardado (o teste prende-o), como na latencia.
export const VOICE_INTERVALS = [0, 1000, 2000, 5000, 10000, 15000, 20000, 30000, 45000, 60000, 90000];
const OPEN_STEP = 90000;

const seconds = (ms) => String(ms / 1000);

const intervalLabel = (index, translate) => {
  const from = VOICE_INTERVALS[index];
  const to = VOICE_INTERVALS[index + 1];
  if (index === 0) return translate("analyticsLatencyUnder", { to: seconds(to) });
  if (to === undefined) return translate("analyticsSecondsOrMore", { value: seconds(from) });
  return translate("analyticsLatencyRange", { from: seconds(from), to: seconds(to) });
};

export const voiceDurationBars = (histogram, translate) => {
  const totals = VOICE_INTERVALS.map(() => 0);
  Object.entries(histogram).forEach(([start, count]) => {
    const index = VOICE_INTERVALS.filter((intervalStart) => intervalStart <= Number(start)).length - 1;
    totals[index] += count;
  });
  return VOICE_INTERVALS.map((start, index) => ({ key: String(start), label: intervalLabel(index, translate), value: totals[index] }));
};

// Corta a decima, nao arredonda, como o formatLatency: 89 950 nunca se le "90,0 s" ao lado do "90 s ou mais".
export const formatVoiceDuration = (ms, language, translate) => {
  if (ms === null) return translate("analyticsNotAvailable");
  if (ms >= OPEN_STEP) return translate("analyticsSecondsOrMore", { value: seconds(OPEN_STEP) });
  return `${formatDecimal(Math.floor(ms / 100) / 10, language)} s`;
};
